import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterCategory } from 'src/app/shared/interface/shared-interface';

@Component({
  selector: 'app-category-filters',
  templateUrl: './category-filters.component.html',
  styleUrls: ['./category-filters.component.css']
})
export class CategoryFiltersComponent {

  @Input() categoryName: string;
  @Input() soryByData: FilterCategory[] = [];
  @Input() photoFilterData: FilterCategory[] = [];
  @Input() videoCategoryData: FilterCategory[] = [];
  @Input() selectedTag: FilterCategory[] = [];
  @Input() selectedOptions: string[] = [];
  constructor(private activeModel: NgbActiveModal) {
  }
  closeModal() {
    let objResult = Object.assign({});
    objResult.selectedTag = this.selectedTag;
    objResult.selectedOptions = this.selectedOptions;
    this.activeModel.close(objResult);
  }
  toggleSelection(subCategoryDataItem: FilterCategory) {
    subCategoryDataItem.IsSelected = !subCategoryDataItem.IsSelected;
    if (subCategoryDataItem.IsSelected) {
      this.selectedTag.push(subCategoryDataItem);
    }
    else {
      this.selectedTag = this.selectedTag.filter(tag => !(tag.Category === subCategoryDataItem.Category && tag.Id === subCategoryDataItem.Id));
    }
  }
  setPhotoFilter(item: FilterCategory) {
    item.IsSelected = true;
    this.selectedTag = this.selectedTag.filter(x => x.Category != 3);
    this.selectedTag.push(item);
  }
  setSortFilter(item: FilterCategory) {
    item.IsSelected = true;
    this.selectedTag = this.selectedTag.filter(x => x.Category != 2);
    this.selectedTag.push(item);
  }
  setCategoryFilter(item: FilterCategory) {
    item.IsSelected = true;
  }
}
